/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseIcon.vue?vue&type=template&id=6dfef1fb&scoped=true&functional=true&"
import script from "./BaseIcon.vue?vue&type=script&lang=js&"
export * from "./BaseIcon.vue?vue&type=script&lang=js&"
import style0 from "./BaseIcon.vue?vue&type=style&index=0&id=6dfef1fb&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "6dfef1fb",
  null
  
)

export default component.exports